import { apiClient } from "@api/client";
import { request } from "@api/request";
import { ClinicAuthError } from "@auth/clinicAuthClient";

export interface ClinicBranding {
  address: string | null;
}

export const ALLOWED_LOGO_TYPES = [
  "image/png",
  "image/jpeg",
  "image/svg+xml",
  "image/webp",
];

export const clinicBrandingClient = {
  setBranding: async (branding: ClinicBranding): Promise<void> => {
    await request(() =>
      apiClient.PATCH("/auth/clinic/branding", {
        body: { address: branding.address },
      }),
    );
  },

  // Only the S3 PUT is a bare fetch: the presigned URL carries its own signature.
  uploadLogo: async (file: File): Promise<void> => {
    if (!ALLOWED_LOGO_TYPES.includes(file.type))
      throw new ClinicAuthError(
        "unknown",
        `Unsupported logo type: ${file.type}`,
      );

    const { upload_url } = await request(() =>
      apiClient.POST("/auth/clinic/logo", {
        body: { content_type: file.type },
      }),
    );

    let put: Response;
    try {
      // The PUT's Content-Type must match what the presign signed (`file.type`).
      put = await fetch(upload_url, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": file.type },
      });
    } catch {
      throw new ClinicAuthError("network_error");
    }
    if (!put.ok) {
      console.error("Logo S3 PUT failed:", put.status, put.statusText);
      throw new ClinicAuthError(
        "unknown",
        `Logo upload failed: ${put.status}`,
        put.status,
      );
    }

    await request(() => apiClient.POST("/auth/clinic/logo/complete", {}));
  },
};
